import VideoPlayerEndedPreviewEntitled from './VideoPlayerEndedPreviewEntitled'

export default VideoPlayerEndedPreviewEntitled
// eslint-disable-next-line import/export
export * from './VideoPlayerEndedPreviewEntitled'
